import React, { Component } from 'react';

import './pdfjslib.css'
import $ from 'jquery';
import { fabric } from 'fabric';
import SignatureCanvas from 'react-signature-canvas';
import {
    Spin,
} from "antd";
import {
    SyncOutlined,
} from "@ant-design/icons";
import { pdfjs } from 'react-pdf';
import { jsPDF } from "jspdf";
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';
import html2pdf from 'html2pdf.js'

pdfjs.GlobalWorkerOptions.workerSrc = `pdf.worker-2.9.359.min.js`;

const antIcon = <SyncOutlined style={{ fontSize: 24 }} spin />;

let number_of_pages = 0;
let pages_rendered = 0;
let active_tool = 1; // 1 - Free hand, 2 - Text, 3 - Arrow, 4 - Rectangle
let fabricObjects = [];
let fabricObjectsData = [];
let color = '#212121';
let borderColor = '#000000';
let borderSize = 1;
let font_size = 16;
let active_canvas = 0;
let container_id = 'pdfjslib-container';


export default class PdfjsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            url: props.url,
            options: props.options ? props.options : null,
            pageImageCompression: props.options ? props.options.pageImageCompression
                ? props.options.pageImageCompression.toUpperCase()
                : "NONE" : null,
            esignImage: false,
            pencilEnabled: false,
            isLoading: false,
            esignImagesArray: [],
            pdfLoaded: false,
            activeCanvas: 0,
        };

        this.pdfFunction = this.pdfFunction.bind(this);
        this.initialize = this.initialize.bind(this);
        this.initFabric = this.initFabric.bind(this);
        this.savePdfDoc = this.savePdfDoc.bind(this);
    }


    componentDidMount() {
        this.setState({ isLoading: true });

        let count = 0;
        const checkInterval = () => {
            if (count <= 20) {
                setTimeout(() => {
                    count++;
                    if (this.props.url) {

                        if (this.props.url) {
                            localStorage.removeItem('pdfurl');
                            localStorage.setItem('pdfurl', this.props.url);
                            //alert(this.props.url)
                        }
                        // this.initialize();
                        const reloadCount = sessionStorage.getItem('reloadCount') ? sessionStorage.getItem('reloadCount') : 1;
                        if (reloadCount < 2) {
                            sessionStorage.setItem('reloadCount', String(2));
                            window.location.reload(false);
                        } else {
                            sessionStorage.removeItem('reloadCount');
                            this.initialize();
                        }

                    }
                    else {
                        checkInterval();
                    }
                }, 1000);
            }
            else {
                alert("can't get url..!");
            }
        }

        checkInterval();



        // this.intervaltime = setTimeout(() => {

        // }, 1000);

        // this.initialize();

    }



    initialize() {
        const pdfurl = localStorage.getItem('pdfurl') ? localStorage.getItem('pdfurl') : this.props.url;
        //const pdfurl = this.props.url?this.props.url:localStorage.getItem('pdfurl')
        this.setState({ url: pdfurl }, () => { //alert(this.state.url)
            this.pdfFunction(this.state.url, this.state.options);
            //fabricObjects[0].click();
            // this.pdfFuntionInterval = setTimeout(() => {
            //     this.pdfFunction(this.state.url,this.state.options);
            // }, 1000);

        })
        // 
    }

    componentWillUnmount() {
        clearTimeout(this.intervaltime);
        // clearTimeout(this.initFabricInterval);
        clearTimeout(this.pdfFuntionInterval);
    }

    pdfFunction = (pdfurl, options = {}) => {
        this.setState({ isLoading: false });
        let THAT = this;
        //let container_id = container_id;
        let url = pdfurl;
        let pageImageCompression = this.state.pageImageCompression ? this.state.pageImageCompression.toUpperCase()
            : "NONE";
        let textBoxText = 'Sample Text';
        let format;
        let orientation;


        var loadingTask = pdfjs.getDocument(url);
        loadingTask.promise.then(function (pdf) {
            var scale = THAT.state.options ? THAT.state.options.scale ? THAT.state.options.scale : 1.3 : 1.3;
            number_of_pages = pdf.numPages;
            let noOfPages = pdf.numPages;
            let pagesRendered = 0;
            for (var i = 1; i <= pdf.numPages; i++) {
                pdf.getPage(i).then(function (page) {
                    if (typeof format === 'undefined' ||
                        typeof orientation === 'undefined') {
                        var originalViewport = page.getViewport({ scale: 1 });
                        format = [originalViewport.width, originalViewport.height];
                        orientation =
                            originalViewport.width > originalViewport.height ?
                                "landscape" :
                                "portrait";
                    }

                    var viewport = page.getViewport({ scale: scale });
                    var canvas = document.createElement('canvas');
                    document.getElementById(container_id).appendChild(canvas);
                    canvas.className = 'pdf-canvas';
                    canvas.height = viewport.height;
                    canvas.width = viewport.width;
                    var context = canvas.getContext('2d');

                    var renderContext = {
                        canvasContext: context,
                        viewport: viewport
                    };
                    var renderTask = page.render(renderContext);
                    renderTask.promise.then(function () {
                        $('.pdf-canvas').each(function (index, el) {
                            $(el).attr('id', 'page-' + (index + 1) + '-canvas');
                        });
                        pages_rendered++;
                        pagesRendered++;
                        if (pagesRendered == noOfPages) {
                            THAT.initFabric();
                            // THAT.initFabricInterval = setTimeout(() => {
                            //     THAT.initFabric();
                            // }, 1000);

                        }
                        // if (pages_rendered == number_of_pages) { alert('h')
                        //     THAT.initFabric();
                        // }
                    });
                });
            }
        }, function (reason) {
            console.error(reason);
        });
    }

    initFabric() {
        let TH = this;
        // let canvases = $('#' + container_id + ' canvas')
        let canvases = $('#pdfjslib-container canvas')
        canvases.each(function (index, el) {
            var background = el.toDataURL("image/png");
            var fabricObj = new fabric.Canvas(el.id, {
                // isDrawingMode : true,
                freeDrawingCursor: 'text',
                freeDrawingBrush: {
                    width: 100,
                    color: color
                }

            });
            fabricObj.setDimensions({ width: el.width, height: el.height });
            fabricObjects.push(fabricObj);

            fabricObj.on('object:added', function () {
                active_canvas = index;
                TH.setState({ activeCanvas: index })
            })
            fabricObj.setBackgroundImage(background, fabricObj.renderAll.bind(fabricObj));
            //TH.setState({activeCanvas:0});
            $(fabricObj.upperCanvasEl).on('click', function (event) {
                active_canvas = index;
                TH.setState({ activeCanvas: index })
                //inst.fabricClickHandler(event, fabricObj);
            });
            // $(fabricObj.upperCanvasEl).click(function (event) {
            //     active_canvas = index;
            //     //inst.fabricClickHandler(event, fabricObj);
            // });
            fabricObj.on('after:render', function () {
                fabricObjectsData[index] = fabricObj.toJSON()
                fabricObj.off('after:render')
            })
            fabricObj.on('object:modified', function (e) {
                // console.log(e);
                // console.log(fabricObjectsData[index]) 
            });
            // if (index === canvases.length - 1 &&  typeof this.state.options.ready === 'function') {
            //     this.state.options.ready()
            // }
        });
        this.setState({ isLoading: false });
    }
    //         initFabric() {
    //             let TH = this;
    //             // let canvases = $('#' + container_id + ' canvas')
    //             let canvases = $('#pdfjslib-container canvas')
    //             canvases.each(function (index, el) {
    //                 var background = el.toDataURL("image/png");
    //                 var fabricObj = new fabric.Canvas(el.id, {
    //                     // isDrawingMode : true,
    //                      freeDrawingCursor: 'text',
    //                     freeDrawingBrush: {
    //                         width: 100,
    //                         color: color
    //                     }

    //                 });
    //                 fabricObj.setDimensions({width:el.width, height:el.height});
    //                 // fabricObj.isDrawingMode = true;
    //                 // fabricObj.freeDrawingBrush.width = 25;
    //                 // fabricObj.freeDrawingBrush.color = "rgba(253,255,0,.4)";
    //                 // fabricObj.freeDrawingBrush.freeDrawingCursor = 'text';
    //                 fabricObjects.push(fabricObj);

    //                 fabricObj.on('object:added', function() { 
    // 					active_canvas = index;
    //                     TH.setState({activeCanvas:index})
    // 				})

    //                     // if (typeof this.state.options.onPageUpdated == 'function') {
    //                     //     fabricObj.on('object:added', function() {
    //                     //         var oldValue = Object.assign({}, fabricObjectsData[index]);
    //                     //         fabricObjectsData[index] = fabricObj.toJSON()
    //                     //         this.state.options.onPageUpdated(index + 1, oldValue, fabricObjectsData[index]) 
    //                     //     })
    //                     // }


    //                 fabricObj.setBackgroundImage(background, fabricObj.renderAll.bind(fabricObj));
    //                 //TH.setState({activeCanvas:0});

    //                 $(fabricObj.upperCanvasEl).on('click',function (event) { 
    //                     active_canvas = index;
    //                     TH.setState({activeCanvas:index})
    //                     //inst.fabricClickHandler(event, fabricObj);
    //                 });
    // // console.log('fabricObj.upperCanvasEl',fabricObj.upperCanvasEl)
    //                 // $(fabricObj.upperCanvasEl).on('mouseup',function (event) { 
    //                 //     console.log(event)
    //                 //     var xx = 0, yy = 0;
    //                 //     var marginLeft = $(this).parent().css('margin-left').replace('px', '');
    //                 //     var borderLeft = $(this).parent().css('border-left-width').replace('px', '');
    //                 //     var offset_ = $(this).offset();
    //                 //     xx = event.pageX - parseFloat(marginLeft) - parseFloat(borderLeft);
    //                 //     yy = event.pageY - offset_.top;
    //                 //     //alert("pageX: " + x + ", pageY: " + y+ ", Margin-left: " + marginLeft);
    //                 //     console.log("Fine " + xx + " " + yy);
    //                 // });
    //                 // $(fabricObj.upperCanvasEl).click(function (event) {
    //                 //     active_canvas = index;
    //                 //     //inst.fabricClickHandler(event, fabricObj);
    //                 // });
    //                 fabricObj.on('after:render', function () {
    //                     fabricObjectsData[index] = fabricObj.toJSON()
    //                     fabricObj.off('after:render')
    //                 })
    //                 fabricObj.on('object:modified',function (e) {
    //                     console.log(e);
    //                     console.log(fabricObjectsData[index])
    //                      //alert(active_canvas+1)
    //                      //alert('Modified object x,y: ' + this.getActiveObject().get('left') + ' ' + this.getActiveObject().get('left') + ' it\'s id is: ' + this.getActiveObject()._objects[0].id);  
    //                 });
    //                 // if (index === canvases.length - 1 &&  typeof this.state.options.ready === 'function') {
    //                 //     this.state.options.ready()
    //                 // }
    //             });
    //             this.setState({isLoading:false});
    //         }


    async modifyPdf(url, pageNo) {
        const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer())

        const pdfDoc = await PDFDocument.load(existingPdfBytes)
        const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)

        const pages = pdfDoc.getPages()
        const pdfPage = pages[pageNo]
        const { width, height } = pdfPage.getSize()
        pdfPage.drawText('This text was added with JavaScript!', {
            x: 5,
            y: height / 2 + 300,
            size: 50,
            font: helveticaFont,
            color: rgb(0.95, 0.1, 0.1),
            rotate: degrees(-45),
        })

        const pdfBytes = await pdfDoc.save()
    }



    getPencilState() {
        return this.state.pencilEnabled;
    }

    eSignFn(c) {
        let TH = this;
        // this.deleteSelectedObject();
        TH.setState({ esignImage: c }, () => {
            // this.setState(prevState => ({
            //   esignImagesArray: [...prevState.esignImagesArray, {img:c,pdfPage:active_canvas+1}]
            // }))

            TH.setState(prevState => ({
                esignImagesArray: [...prevState.esignImagesArray, { img: c, pdfPage: TH.state.activeCanvas + 1 }]
            }))

            var imgElement = document.getElementById('simage');
            var img = document.createElement('img');
            img.src = TH.state.esignImage;
            img.onload = function () {
                var imgInstance = new fabric.Image(img, {
                    left: 100,
                    top: 100,
                    opacity: 0.85
                });

                //   var fabricObj = fabricObjects[active_canvas];
                var fabricObj = fabricObjects[TH.state.activeCanvas];
                if (fabricObj) {
                    fabricObj.add(imgInstance);
                }
            }


        })
    }


    deleteSelectedObject() {
        // var activeObject = fabricObjects[active_canvas].getActiveObject();
        var activeObject = fabricObjects[this.state.activeCanvas].getActiveObject();
        if (activeObject) {
            //  fabricObjects[active_canvas].remove(activeObject);
            fabricObjects[this.state.activeCanvas].remove(activeObject);
        }
    }
    savePdfDoc1(fileName) {
        // var pdf_content = document.getElementById("pdfjslib-container");
        // var options = {
        //     margin:       1,
        //     filename:     'isolates.pdf',
        //     //image:        { type: 'jpeg', quality: 0.98 },
        //     //html2canvas:  { scale: 1 },
        //     jsPDF:        { format: 'a4', orientation: 'portrait' }
        //     // jsPDF:        { unit: 'in', format: 'letter', orientation: 'portrait' }
        //   };
        //   html2pdf(pdf_content, options);
        var element = document.getElementById('pdfjslib-container');
        var opt = {
            margin: 1,
            filename: 'myfile.pdf',
            image: { type: 'png', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
        };

        // New Promise-based usage:
        html2pdf().set(opt).from(element).save();
        // let format =  'a4';
        // let orientation =  "portrait";

        // var specialElementHandlers = {
        //     '#editor': function (element, renderer) {
        //         return true;
        //     }
        // };

        // let doc = new jsPDF({format, orientation});

        // doc.html($('#pdfjslib-container').html(), {
        //     elementHandlers: specialElementHandlers,
        //     callback: function (doc) {
        //       doc.save('new-pdf-file.pdf');
        //     },
        //     //x: 10,
        //    // y: 10
        //  });


        // doc.html($('#pdfjslib-container').html(), 15, 15, {
        //     'width': 170,
        //         'elementHandlers': specialElementHandlers
        // });
        // doc.save('sample-file.pdf');
    }

    savePdfDoc(fileName) {
        let format = 'a4';
        let orientation = "portrait";
        if (!fabricObjects.length) return;
        let doc = new jsPDF({ format, orientation });
        if (typeof fileName === 'undefined') {
            fileName = `${new Date().getTime()}.pdf`;
        }

        fabricObjects.forEach(function (fabricObj, index) {
            if (index != 0) {
                doc.addPage(format, orientation);
                doc.setPage(index + 1);
            }
            let imgData = fabricObj.toDataURL({
                format: 'png'
            });

            doc.addImage(imgData,
                'PNG',
                0,
                0,
                doc.internal.pageSize.getWidth(),
                doc.internal.pageSize.getHeight(),
                `page-${index + 1}`, "FAST");
            // doc.addImage(
            //     dtUrl, 
            //     this.state.pageImageCompression == "NONE" ? "PNG" : "JPEG", 
            //     0, 
            //     0,
            //     doc.internal.pageSize.getWidth(), 
            //     doc.internal.pageSize.getHeight(),
            //     `page-${index + 1}`, 
            //     ["FAST", "MEDIUM", "SLOW"].indexOf(this.state.pageImageCompression) >= 0
            //     ? this.state.pageImageCompression
            //     : undefined
            // );
            if (index === fabricObjects.length - 1) {
                doc.save(fileName);
            }
        })
    }


    printPdfDoc(fileName) {
        let format = 'a4';
        let orientation = "portrait";
        if (!fabricObjects.length) return;
        let doc = new jsPDF({ format, orientation });
        if (typeof fileName === 'undefined') {
            fileName = `${new Date().getTime()}.pdf`;
        }

        fabricObjects.forEach(function (fabricObj, index) {
            if (index != 0) {
                doc.addPage(format, orientation);
                doc.setPage(index + 1);
            }
            let imgData = fabricObj.toDataURL({
                format: 'png'
            });

            doc.addImage(imgData,
                'PNG',
                0,
                0,
                doc.internal.pageSize.getWidth(),
                doc.internal.pageSize.getHeight(),
                `page-${index + 1}`, "FAST");
            if (index === fabricObjects.length - 1) {
                //doc.save(fileName);
                doc.autoPrint();
                // doc.output('dataurlnewwindow');
                window.open(doc.output('bloburl'), '_blank');
                // doc.output('dataurlnewwindow');
            }
        })
    }

    getPdfDoc() {
        let pdfDoc;
        let format = 'a4';
        let orientation = "portrait";
        if (!fabricObjects.length) return;
        let doc = new jsPDF({ format, orientation });
        fabricObjects.forEach(function (fabricObj, index) {
            if (index != 0) {
                doc.addPage(format, orientation);
                doc.setPage(index + 1);
            }
            let imgData = fabricObj.toDataURL({
                format: 'png'
            });

            doc.addImage(imgData,
                'PNG',
                0,
                0,
                doc.internal.pageSize.getWidth(),
                doc.internal.pageSize.getHeight(),
                `page-${index + 1}`, "FAST");
            if (index === fabricObjects.length - 1) {
                pdfDoc = doc.output('blob');
            }
        })
        return pdfDoc;
    }

    render() {
        return (
            <div style={{ width: '100%' }} >
                {/* <div style={{width:'100%'}} >
            <Spin indicator={antIcon} style={{alignItems: 'center',justifyContent:'center',justifyItems:'center',textAlign:'center',width:'100%',maxWidth:'100%',maxHeight:'100%',position:'fixed',zIndex:1111,left:0,right:0,top:'45%',bottom:0}} spinning={this.state.isLoading} />
            </div> */}

                <div style={{ width: '100%' }} id="pdfjslib-container"></div>
                <div style={{ width: 200, height: 200, visibility: 'hidden' }} ><img id="simage" src={this.state.esignImage} style={{ width: '100%', height: '100%', visibility: 'hidden' }} /></div>
                <Spin indicator={antIcon} style={{ alignItems: 'center', justifyContent: 'center', justifyItems: 'center', textAlign: 'center', width: '100%', maxWidth: '100%', maxHeight: '100%', zIndex: 1111, left: 0, right: 0, top: '45%', bottom: 0 }} spinning={this.state.isLoading} />
                <div id="editor"></div>
            </div>
        );
    }
}
